import { useState, useEffect, useCallback } from "react";
import axios, { AxiosError } from "axios";
import api from "shared/api/client"; // path-аа өөрийн folder-т тааруул

interface ApiError {
  message: string;
}

function useFetchData<T>(url: string) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<ApiError | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.get<T>(url);
      setData(response.data);
    } catch (err) {
      const axiosError = err as AxiosError<any>;

      if (axios.isAxiosError(axiosError) && axiosError.response) {
        setError({
          message:
            axiosError.response.data?.message ||
            axiosError.response.statusText ||
            "Request failed",
        });
      } else {
        setError({ message: "An error occurred" });
      }
    } finally {
      setLoading(false);
    }
  }, [url]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}

export default useFetchData;
